import { hasSameKeys, hasAnyKeyEmpty } from "../utils/objects";
import authService from "../services/authService";
import SessionListener from "../utils/session-listener";

const CARRERS_AUTHENTICATION_EMPTY_OBJECT = {
  name: "value",
  email: "value",
  accessToken: "value"
}

const CARRERS_SOCIAL_AUTHENTICATION_EMPTY_OBJECT = {
  name: "value",
  email: "value",
  socialNetToken: "value"
}

export const isAuthenticatedCarrers = () => {
  let carrersAuthentication = window.sessionStorage.getItem('carrersAuthentication');

  try {
    if (carrersAuthentication !== null || carrersAuthentication !== undefined) {
      carrersAuthentication = JSON.parse(carrersAuthentication);
      return (
        !hasAnyKeyEmpty(carrersAuthentication) 
        && (
          hasSameKeys(CARRERS_SOCIAL_AUTHENTICATION_EMPTY_OBJECT, carrersAuthentication)
          || hasSameKeys(CARRERS_AUTHENTICATION_EMPTY_OBJECT, carrersAuthentication)
        )
      )
    } else {
      return false;
    }
  } catch {
    return false;
  }
}

export const setCarrersAuthentication = (authUser) => {  
  window.sessionStorage.setItem("carrersAuthentication", JSON.stringify(authUser));
  SessionListener.insertedItem("carrersAuthentication");

}

export const getCarrersAuthentication = () => {
  let carrersAuthentication = window.sessionStorage.getItem('carrersAuthentication');

  if (carrersAuthentication !== null || carrersAuthentication !== undefined) {
    carrersAuthentication = JSON.parse(carrersAuthentication);

    return carrersAuthentication;
  }
  
  return null;
}

export const setCarrersAccessToken = (accessToken) => {
  let carrersAuthentication = getCarrersAuthentication();

  carrersAuthentication.accessToken = accessToken;

  window.sessionStorage.setItem("carrersAuthentication", JSON.stringify(carrersAuthentication));
  SessionListener.insertedItem("carrersAuthentication");
}

export const removeCarrersAuthentication = () => {
  if(getCarrersAuthentication())
    window.sessionStorage.removeItem("carrersAuthentication");
}

export const renewAccessToken = async (accessToken) => {
  let res = await authService.renewToken(accessToken);
  setCarrersAuthentication({
    name: res.name,
    email: res.email ? res.email : res.login,
    socialNetToken: res.accessToken.token
  });
}
